import { Navbar,Feed,VideoDetail,ChannelDetail,SearchDetail } from "./Components"
import { Box } from "@mui/material"
import { BrowserRouter, Route, Routes } from "react-router-dom"



const App = () => {
  return (
    <div className=''>
      <BrowserRouter>
      <Box sx={{backgroundColor:"#000 ", color:"#fff"}}>
        <Navbar/>
      <Routes>
        <Route exact path="/" element={<Feed/>}/>
        <Route  path="/videos/:id" element={<VideoDetail/>}/>
        <Route  path="/channel/:id" element={<ChannelDetail/>}/>
        <Route  path="/search/:searchTerm" element={<SearchDetail/>}/>
      </Routes>
      </Box>
      </BrowserRouter>
    </div>
  )
}

export default App
